// =============================================
// COMPONENTE: ABASTECIMENTO NODE
// =============================================
// Arquivo: AbastecimentoNode.tsx
// Descricao: No para operacoes com abastecimentos
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Database } from 'lucide-react';
import ActionsBadge from './ActionsBadge';

const AbastecimentoNode: React.FC<NodeProps> = ({ data, selected }) => {
  const { label, operation, veiculo_id, volume, custo, tipo_combustivel, description, actions } = data;

  const getOperationLabel = (op: string) => {
    const labels: Record<string, string> = {
      create: 'Registrar',
      find: 'Buscar',
      list: 'Listar'
    };
    return labels[op] || op;
  };

  return (
    <div className={`flow-node abastecimento-node ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Top} className="flow-handle" />

      <div className="node-header abastecimento-header" style={{ backgroundColor: '#22c55e' }}>
        <Database className="node-icon" size={18} />
        <span className="node-title">{label || 'Abastecimento'}</span>
      </div>

      <div className="node-body">
        {operation && (
          <div className="node-field">
            <span className="field-label">Operacao:</span>
            <span className="field-value">{getOperationLabel(operation)}</span>
          </div>
        )}
        {veiculo_id && (
          <div className="node-field">
            <span className="field-label">Veiculo:</span>
            <span className="field-value code">{veiculo_id}</span>
          </div>
        )}
        {volume && (
          <div className="node-field">
            <span className="field-label">Volume:</span>
            <span className="field-value">{volume}L</span>
          </div>
        )}
        {custo && (
          <div className="node-field">
            <span className="field-label">Custo:</span>
            <span className="field-value">R$ {custo}</span>
          </div>
        )}
        {tipo_combustivel && (
          <div className="node-field">
            <span className="field-label">Combustivel:</span>
            <span className="field-value">{tipo_combustivel}</span>
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle type="source" position={Position.Bottom} className="flow-handle" />
    </div>
  );
};

export default AbastecimentoNode;
